export default {
    visitorCreate: 'Create Visitor',
    visitorEdit: 'Edit Visitor',
    createNewVisitor: 'Create New Visitor',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    citizenIdPassportId: 'Citizen ID / Passport ID',
    name: 'Name',
    enterVisitorName: 'Enter Visitor Name',
    surname: 'Surname',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    visitAt: 'Visit At',
    selectBureau: '- Select Bureau -',
    emailAddress: 'Email address',
    enterEmailAddress: 'Enter email address',
    phoneNumber: 'Phone number',
    operator: 'Operator',
    operatorDetial: 'Enter Employee to send notification (via Line) when visitor arrived.',
    selectPermission: '- Select Permission -',
    selectEmployeeName: 'Search Employee',
    uploadIdCard: 'Upload ID card',
    pngMaxSizeMb: 'Note: JPG or PNG max size 10 MB',
    accessInformation: 'Access information',
    startTime: 'Start time',
    endTime: 'End time',
    setUpTimeRangeDay: 'Set up time range per 1 day',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceeded255Characters: 'This field is exceeded 255 characters',
    emailIsRequired: 'E-mail is required',
    emailIsExceeded255Characters: 'E-mail is exceeded 255 characters',
    invalidEMailFormat: 'Invalid e-mail format',
    incorrectPhoneNumber: 'Incorrect Phone Number',
    ImageSizeCanNot200Kb: 'Image size can not be less than 25KB or more than 200KB',
    ImageSizeCanNot10Mb: 'Image size can not be less than 25KB or more than 10MB',
    StartInTimeMustBeLess: 'Start in time must be less than check in time.',
    EndInTimeMustBeMore: 'End in time must be more than last.'
}
